module.exports = __webpack_public_path__ + "img/15.aec5188a.jpg";